export default defineNuxtRouteMiddleware ((to, from) => {
  if (true) {
    if (from.path.includes('/dashboard/lots/edit')) {
      useLot().resetLotToEditSpots(Number(localStorage.getItem('SPOTS')));
      localStorage.removeItem('SPOTS');
    }
  }
});
